import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { WorkoutRetrieve } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface UseWorkoutDetailsByTypeParams {
  kiloClassTypeId: string | undefined;
  date: string | undefined;
}

function useWorkoutDetailsByType({
  kiloClassTypeId,
  date,
}: UseWorkoutDetailsByTypeParams): UseQueryResult<AxiosResponse<WorkoutRetrieve | undefined>> {
  return useQuery(
    ['workouts', 'details', 'by-type', kiloClassTypeId, date],
    () =>
      client.get<WorkoutRetrieve>(
        `workouts/details/?${encodeUrlParams({ kilo_class_type: kiloClassTypeId!, date: date! })}`,
      ),
    {
      enabled: !!kiloClassTypeId && !!date,
    },
  );
}

export default useWorkoutDetailsByType;
